"use client";

import { notFound, usePathname, useRouter } from "next/navigation";
import { listSideBar } from "@/functions/dinamisData";
import { useMemo } from "react";
import Sidebar from "./Sidebar";
import useHeader from "@/functions/useHeader";
import Loading from "@/components/atom/Loading";
import useDelayedRender from "@/functions/useDelayedRender";

export default function DummyLayout({ children }) {
  const shouldRendered = useDelayedRender(100);

  const router = useRouter();
  const pathname = usePathname();
  const { session, status } = useHeader();

  const checkPath = useMemo(() => {
    let datas = listSideBar();
    datas =
      session?.user?.data?.mitra_level < 5
        ? datas
        : datas?.map((val) => {
            let ka = val;
            if (ka?.href == "list-order") {
              ka.label = "Transaksi Saya";
              ka.href = "daftar-transaksi";
            }
            if (ka?.href == "customer-saya") {
              ka.label = "Daftar Alamat";
              ka.href = "daftar-alamat";
              ka.anotherHref = [
                "daftar-alamat/tambah-alamat",
                "daftar-alamat/edit-alamat",
              ];
            }
            return ka;
          });

    return datas?.find(
      (val) =>
        val?.anotherHref?.find(
          (value) => `/member-area/${value}` == pathname
        ) || pathname === `/member-area/${val?.href}`
    );
  }, [pathname, listSideBar, session?.user?.data?.mitra_level]);

  if (status == "loading") return <Loading versi={2} />;

  if (
    !checkPath ||
    (session?.user?.data?.mitra_level > 2 && // Selain Distributor
      (checkPath.href == "dompet-digital" || checkPath?.href == "jaringan-saya" ||
        (session?.user?.data?.mitra_level > 4 &&
          (checkPath.href == "laporan-belanja"))))
  ) {
    return notFound();
  }

  if (status == "authenticated") {
    return (
      shouldRendered && (
        <div className='w-full'>
          <div className='flex flex-col md:flex-row'>
            <Sidebar />
            {children}
          </div>
        </div>
      )
    );
  } else {
    return router.push("/");
  }
}
